import { ConversationSummary } from '@types';
import { CoreAgentConversationTitlesName } from './name';
import { createAddSyncSlice } from '@sonar-software/xuder';
import { defaultAgentConversationTitlesState } from './state';

export const addCoreAgentConversationTitlesSyncSlice = createAddSyncSlice({
	name: CoreAgentConversationTitlesName,
	state: defaultAgentConversationTitlesState,
	transform: (summaries: Array<Pick<ConversationSummary, 'id' | 'title'>>, state = {}) => {
		for (const { id, title } of summaries) {
			if (title !== null) {
				state[ id ] = {
					status: 'ready',
					title
				};
			} else if (!state[ id ]) {
				state[ id ] = {
					status: 'gaveUp',
					title: null
				};
			}
		}

		return state;
	}
});
